/* tslint:disable */
/* eslint-disable */
export enum ClientType {
  Business = 'BUSINESS',
  Customer = 'CUSTOMER',
  International = 'INTERNATIONAL',
  Government = 'GOVERNMENT',
}
